import PropTypes from 'prop-types'
import React from 'react'
import styles from './_statsTable.css'
import { FormattedDistance } from 'shared/units'
import { FormattedDuration } from 'shared/units'
import { FormattedEnergy } from 'shared/units'
import { LONG } from 'shared/units/constants'
import { FormattedMessage } from 'react-intl'

export default function StatsTable ({ individualWorkoutStats, totals }) {
  return (
    <section>
      <table className={styles.tableContainer}>
        <thead>
          <tr>
            <th><FormattedMessage id='statstable.types' defaultMessage='Type' /></th>
            <th><FormattedMessage id='statstable.number' defaultMessage='#' /></th>
            <th><FormattedMessage id='statstable.distance' defaultMessage='Distance' /></th>
            <th><FormattedMessage id='statstable.duration' defaultMessage='Duration' /></th>
            <th><FormattedMessage id='statstable.energy' defaultMessage='Energy' /></th>
          </tr>
        </thead>
        <tbody>
          {individualWorkoutStats.map((stat, i) => {
            return (<tr key={i}>
              <td>{stat.activity_name}</td>
              <td>{stat.activity_count}</td>
              <td><FormattedDistance value={stat.distance} digits={2} /></td>
              <td><FormattedDuration value={stat.duration} digits={2} unit={LONG} /></td>
              <td><FormattedEnergy from='joules' value={stat.energy} digits={0} /></td>
            </tr>)
          })}
        </tbody>
        <tfoot>
          <tr className={styles.totalsRow}>
            <td>
              <FormattedMessage id='statstable.totals' defaultMessage='Totals' />
            </td>
            <td>
              {totals.activity_count}
            </td>
            <td>
              <FormattedDistance value={totals.distance} digits={2} />
            </td>
            <td>
              <FormattedDuration value={totals.duration} digits={2} unit={LONG} />
            </td>
            <td>
              <FormattedEnergy from='joules' value={totals.energy} digits={0} />
            </td>
          </tr>
        </tfoot>
      </table>
    </section>
  )
}

StatsTable.propTypes = {
  individualWorkoutStats: PropTypes.array,
  totals: PropTypes.object,
}
